<template>
  <v-layout justify-center align-center>
    <div style="width: 80%">
      <migration-alert-component></migration-alert-component>

      <v-card class="pa-4" v-if="!loading">
        <v-card-text style="color: black;">
          <!-- Not paid -->
          <div v-if="customer && !customer.has_paid">
            <span class="headline">
              This domain has not paid for the extension.
            </span>

            <p>
              The extension needs to be manually activated. Please contact
              Online Partner
              <a href="https://www.onlinepartner.se/kontakta-oss-onlinepartner/"
                >here</a
              >.
            </p>
          </div>

          <!-- Paid -->
          <div v-if="customer && customer.has_paid">
            <span class="headline">Settings for your Google Workspace</span>

            <v-chip-group>
              <v-chip v-for="domain in customer.domains" :key="domain">{{
                domain
              }}</v-chip>
            </v-chip-group>

            <v-divider></v-divider>

            <!-- Mailto -->
            <div style="margin-bottom: 25px;">
              <v-checkbox
                v-model="mailto"
                name="mailto"
                color="primary"
                label="Open Mailto Links"
              ></v-checkbox>

              <span class="body-2">
                <strong
                  >Enabling this setting will open an installed mail client
                  instead of redirecting to a web access instance.</strong
                > </span
              ><br /><br />
              <span class="body-2"
                >Note: Only use this if you are using a custom solution and not
                Outlook web access instance.

                <strong
                  >This setting will not be inherited by the extension if you're
                  running Chrome OS.</strong
                >
              </span>
            </div>

            <v-divider></v-divider>

            <div style="margin-bottom: 25px; margin-top: 25px;">
              <v-text-field
                v-model="webAccessInstance"
                label="Web Access Instance"
              ></v-text-field>
              <span class="body-2">
                <strong
                  >Outlook OWA and Mailto links are the only options that
                  support the Bcc functionality.</strong
                > </span
              ><br /><br />
              <span class="body-2"
                >Note: Please configure the Web Access Instance to the desired
                instance for the extension to work.</span
              >
            </div>

            <v-divider></v-divider>

            <!-- Bcc -->
            <div style="margin-bottom: 25px;">
              <v-checkbox
                v-model="bcc"
                color="primary"
                label="Bcc"
              ></v-checkbox>

              <span class="body-2"
                ><strong
                  >This will only work for Office 365 web access instance and if
                  you have enabled Mailto Links in the settings.</strong
                ></span
              ><br /><br />
              <span class="body-2"
                >Note: Bcc setting is turned off by default and is turned off at
                first login. The Bcc setting enables the Mail Switch Extension
                to send emails with the Bcc field in Outlook. Bcc can also be
                manually configured in the extension.</span
              >
            </div>

            <!-- Lock settings -->
            <div style="margin-bottom: 25px;">
              <v-checkbox
                v-model="locked"
                color="primary"
                label="Lock settings"
              ></v-checkbox>

              <span class="body-2">
                <strong
                  >Enabling this setting will lock the settings for the users of
                  the extension.</strong
                > </span
              ><br />
            </div>

            <v-divider></v-divider>
          </div>
        </v-card-text>

        <v-card-actions v-if="customer && customer.has_paid">
          <v-spacer></v-spacer>
          <v-btn
            class="primary"
            @click="changeSettings"
            :loading="changeSettingsLoading"
            :disabled="changeSettingsLoading"
            >Change settings</v-btn
          >
        </v-card-actions>
      </v-card>
    </div>
  </v-layout>
</template>

<script>
import MigrationAlertComponent from "@/components/MigrationAlertComponent";

import { mapGetters } from "vuex";
export default {
  components: {
    MigrationAlertComponent,
  },

  data: () => ({
    webAccessInstance: null,
    mailto: false,
    bcc: false,
    locked: false,
    changeSettingsLoading: false,
  }),

  computed: {
    ...mapGetters({
      signedIn: "user/signedIn",
      customer: "customer/customer",
      loading: "loading",
    }),
  },

  methods: {
    changeSettings() {
      this.changeSettingsLoading = true;

      this.$store
        .dispatch("customer/changeSettings", {
          payload: {
            bcc: this.bcc,
            mailto: this.mailto,
            web_access_instance: this.webAccessInstance,
            is_locked: this.locked,
          },
        })
        .catch((e) => {
          this.$store.dispatch("error/handle", e);
        })
        .finally(() => {
          this.changeSettingsLoading = false;
        });
    },
  },

  watch: {
    async signedIn(v) {
      if (v) {
        try {
          await this.$store.dispatch("customer/get");
        } catch (e) {
          this.$store.dispatch("error/handle", e);
        }
      }
    },

    customer(v) {
      if (v) {
        this.webAccessInstance = v.settings.web_access_instance;
        this.mailto = v.settings.mailto;
        this.bcc = v.settings.bcc;
        this.locked = v.settings.is_locked;
      }
    },
  },

  async mounted() {
    if (this.signedIn) {
      try {
        await this.$store.dispatch("customer/get");
      } catch (e) {
        this.$store.dispatch("error/handle", e);
      }
    }
  },
};
</script>
